import React, { useState } from "react";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi"; // Import the dropdown icons
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import nodeinstance from "../../../../../nodeInstance";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function FinStatement({
  data,
  fandftrigger,
  setFandfTrigger,
  isLocalExit = false,
  baseEndpoint = '/mobilization',
  repatriationAmount: repatriationAmountProp = 0,
  repatriationSaved = false,
  selectedRepatrationType = null,
  ffSettlementTotal = 0,
  salaryCalculationMode = true,
}) {
  var titles = ["ITEMS", "AMOUNT"];
  // State to manage collapsible section visibility
  const [isCollapsed, setIsCollapsed] = useState(true);
  console.log("FinStatement - Full data object:", data);
  console.log("FinStatement - contractHistory:", data?.contractHistory);
  console.log("FinStatement - contractHistory length:", data?.contractHistory?.length);

  // Log each contract's salary to debug
  data?.contractHistory?.forEach((contract, index) => {
    console.log(`Contract ${index + 1} - basicsalary:`, contract.basicsalary, typeof contract.basicsalary);
  });
  const [amount, SetAmount] = useState(0);
  const [retentionPayable, setRetentionPayable] = useState(0); // F: NET PAYABLE RETENTION
  const [retentionReceivable, setRetentionReceivable] = useState(0); // H: NET RECEIVABLE RETENTION
  const navigate = useNavigate();

  // Load saved retention values from database when data is fetched
  useEffect(() => {
    if (data) {
      console.log("FinStatement - Full data object:", data);
      console.log("FinStatement - Loading saved values from DB:", {
        vpayamount: data.vpayamount,
        NET_PAYABLE_RETENTION: data.NET_PAYABLE_RETENTION,
        NET_RECEIVABLE_RETENTION: data.NET_RECEIVABLE_RETENTION,
        NetPaybale: data.NetPaybale,
        netReceivable: data.netReceivable,
      });

      // Set PAID V.PAY from database
      if (data.vpayamount !== undefined && data.vpayamount !== null) {
        console.log("Setting amount to:", data.vpayamount);
        SetAmount(data.vpayamount);
      }

      // Set retention values from database
      if (data.NET_PAYABLE_RETENTION !== undefined && data.NET_PAYABLE_RETENTION !== null) {
        console.log("Setting retentionPayable to:", data.NET_PAYABLE_RETENTION);
        setRetentionPayable(data.NET_PAYABLE_RETENTION);
      }
      if (data.NET_RECEIVABLE_RETENTION !== undefined && data.NET_RECEIVABLE_RETENTION !== null) {
        console.log("Setting retentionReceivable to:", data.NET_RECEIVABLE_RETENTION);
        setRetentionReceivable(data.NET_RECEIVABLE_RETENTION);
      }
    }
  }, [data]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  function getDaysBetweenDates(date1, date2) {
    const firstDate = date1 ? new Date(date1) : new Date();
    const secondDate = date2 ? new Date(date2) : new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = secondDate - firstDate;

    // Convert milliseconds to days
    // const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const differenceInDays =
      Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

    return differenceInDays;
  }

  // Helper function to calculate contract total
  const calculateContractTotal = (contractHistory, factor) => {
    if (!contractHistory || contractHistory.length === 0) {
      console.log("No contract history available");
      return 0;
    }

    const total = Math.round(
      contractHistory.reduce(
        (total, listItem, index) => {
          // Only calculate if basicsalary exists and is greater than 0
          const salary = parseInt(listItem.basicsalary) || 0;
          console.log(`Contract ${index} - salary: ${salary}, factor: ${factor}`);

          if (salary === 0) {
            console.log(`Contract ${index} skipped - salary is 0`);
            return total;
          }

          const days = getDaysBetweenDates(
            listItem?.employee_contract_end__date,
            listItem?.employee_contract_start__date
          );
          const contractValue = ((((salary / 30) * factor) / 12) * days) / 30.41;
          console.log(`Contract ${index} - days: ${days}, value: ${contractValue}`);

          return total + contractValue;
        },
        0
      )
    );

    console.log(`Total for factor ${factor}: ${total}`);
    return total;
  };

  // Use F&F Settlement Total from Statement component (includes custom columns)
  // Note: We use ffSettlementTotal prop if it's been set (even if 0)
  // OR calculate from saved database values: F&F PAYABLE = GROSS_PAYABLE + PAID_VPAY
  //                                                        = (NET_PAYABLE_AFTER_RETENTION + NET_PAYABLE_RETENTION) + vpayamount
  const savedFFPayable = data?.NET_PAYABLE_AFTER_RETENTION && data?.vpayamount
    ? (data.NET_PAYABLE_AFTER_RETENTION || 0) + (data.NET_PAYABLE_RETENTION || 0) + (data.vpayamount || 0)
    : 0;

  const contractTotal = ffSettlementTotal || savedFFPayable;

  console.log("FinStatement - Contract calculation debug:", {
    hasContractHistory: !!data?.contractHistory,
    contractHistoryLength: data?.contractHistory?.length,
    ffSettlementTotal,
    contractTotal,
    usingPropValue: true,
    firstContract: data?.contractHistory?.[0]
  });

  // Use real-time repatriation amount from parent component if available, otherwise use saved amount
  // Note: We check !== 0 instead of > 0 because repatriation cost can be negative
  const repatriationAmount = repatriationAmountProp !== 0
    ? repatriationAmountProp
    : (data?.data?.[0]?.repatrationAmount || 0);

  // Updated formulas as per new specification:
  // A: F&F PAYABLE = F&F Settlement Total (includes V.PAY + EOSB + all custom columns)
  // B: PAID V.PAY = amount (Manual Entry)
  // C: GROSS PAYABLE = A - B (Calculated: F&F PAYABLE - PAID V.PAY)
  // D: REPATRIATION COST = repatriationAmount (Pulled Data)
  // E: RETAINED FROM PAYABLE = retentionPayable (Manual Entry)
  // F: RETAINED FROM REPATRIATION = retentionReceivable (Manual Entry)
  // G: NET PAYABLE AFTER RETENTION = C - E (Calculated: GROSS PAYABLE - RETAINED FROM PAYABLE)
  // H: NET RECEIVABLE AFTER RETENTION = D - F (Calculated: REPATRIATION COST - RETAINED FROM REPATRIATION)
  // I: FINAL PAYABLE / RECEIVABLE = G - H (Calculated: NET PAYABLE AFTER RETENTION - NET RECEIVABLE AFTER RETENTION)

  const A_FF_PAYABLE = contractTotal;
  const B_PAID_VPAY = parseFloat(amount || 0);
  const C_GROSS_PAYABLE = A_FF_PAYABLE - B_PAID_VPAY;
  const D_REPATRIATION_COST = repatriationAmount;
  const E_RETAINED_FROM_PAYABLE = parseFloat(retentionPayable || 0);
  const F_RETAINED_FROM_REPATRIATION = parseFloat(retentionReceivable || 0);
  const G_NET_PAYABLE_AFTER_RETENTION = C_GROSS_PAYABLE - E_RETAINED_FROM_PAYABLE;
  const H_NET_RECEIVABLE_AFTER_RETENTION = D_REPATRIATION_COST - F_RETAINED_FROM_REPATRIATION;
  const I_FINAL_PAYABLE_RECEIVABLE = G_NET_PAYABLE_AFTER_RETENTION - H_NET_RECEIVABLE_AFTER_RETENTION;

  console.log("FinStatement real-time calculations:", {
    A_FF_PAYABLE,
    B_PAID_VPAY,
    C_GROSS_PAYABLE,
    D_REPATRIATION_COST,
    E_RETAINED_FROM_PAYABLE,
    F_RETAINED_FROM_REPATRIATION,
    G_NET_PAYABLE_AFTER_RETENTION,
    H_NET_RECEIVABLE_AFTER_RETENTION,
    I_FINAL_PAYABLE_RECEIVABLE,
    repatriationAmountProp,
    repatriationAmountFromDB: data?.data?.[0]?.repatrationAmount
  });
  const details = [
    {
      name: "F&F PAYABLE",
      value: A_FF_PAYABLE,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "pulled", // Pulled Data
    },
    {
      name: "PAID V.PAY",
      value: B_PAID_VPAY,
      buttonView: false,
      buttonName: "SAVE",
      isText: true,
      inputType: "manual", // Manual Entry
    },
    {
      name: "GROSS PAYABLE",
      value: C_GROSS_PAYABLE,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "calculated", // Calculated
    },
    {
      name: "REPATRIATION COST",
      value: D_REPATRIATION_COST,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "pulled", // Pulled Data
    },
    {
      name: "RETAINED FROM PAYABLE",
      value: E_RETAINED_FROM_PAYABLE,
      buttonView: false,
      buttonName: "",
      isText: true,
      inputType: "manual", // Manual Entry
    },
    {
      name: "RETAINED FROM REPATRIATION",
      value: F_RETAINED_FROM_REPATRIATION,
      buttonView: false,
      buttonName: "",
      isText: true,
      inputType: "manual", // Manual Entry
    },
    {
      name: "NET PAYABLE AFTER RETENTION",
      value: G_NET_PAYABLE_AFTER_RETENTION,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "calculated", // Calculated
    },
    {
      name: "NET RECEIVABLE AFTER RETENTION",
      value: H_NET_RECEIVABLE_AFTER_RETENTION,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "calculated", // Calculated
    },
    {
      name: "FINAL PAYABLE / RECEIVABLE",
      value: I_FINAL_PAYABLE_RECEIVABLE,
      buttonView: false,
      buttonName: "",
      isText: false,
      inputType: "calculated", // Calculated
    },
  ];

  // Handlers for retention inputs
  const handleRetentionPayableChange = (e) => {
    setRetentionPayable(e.target.value);
  };

  const handleRetentionReceivableChange = (e) => {
    setRetentionReceivable(e.target.value);
  };
  const NewDetails = [
    {
      name: "F&F PAYABLE",
      value: A_FF_PAYABLE, // Use calculated F&F PAYABLE from F&F Settlement total
      buttonView: false,
      buttonName: "",
      isText: false,
    },
    {
      name: "PAID V.PAY",
      value: B_PAID_VPAY, // Use calculated PAID V.PAY
      buttonView: false,
      buttonName: "SAVE",
      isText: true,
    },
    {
      name: "GROSS PAYABLE",
      value: C_GROSS_PAYABLE, // Use calculated GROSS PAYABLE
      buttonView: false,
      buttonName: "",
      isText: false,
    },
    {
      name: "REPATRIATION COST",
      value: D_REPATRIATION_COST, // Use calculated repatriation cost
      buttonView: false,
      buttonName: "",
      isText: false,
    },
    {
      name: "RETAINED FROM PAYABLE",
      value: E_RETAINED_FROM_PAYABLE, // Use calculated retention from payable
      buttonView: false,
      buttonName: "",
      isText: true,
    },
    {
      name: "RETAINED FROM REPATRIATION",
      value: F_RETAINED_FROM_REPATRIATION, // Use calculated retention from repatriation
      buttonView: false,
      buttonName: "",
      isText: true,
    },
    {
      name: "NET PAYABLE AFTER RETENTION",
      value: G_NET_PAYABLE_AFTER_RETENTION, // Use calculated NET PAYABLE AFTER RETENTION
      buttonView: false,
      buttonName: "",
      isText: false,
    },
    {
      name: "NET RECEIVABLE AFTER RETENTION",
      value: H_NET_RECEIVABLE_AFTER_RETENTION, // Use calculated NET RECEIVABLE AFTER RETENTION
      buttonView: false,
      buttonName: "",
      isText: false,
    },
    {
      name: "FINAL PAYABLE / RECEIVABLE",
      value: I_FINAL_PAYABLE_RECEIVABLE, // Use calculated FINAL PAYABLE / RECEIVABLE
      buttonView: false,
      buttonName: "",
      isText: false,
    },
  ];

  const AmountChange = (e) => {
    SetAmount(e.target.value);
  };
  const token = localStorage.getItem("nodeToken");

  const onSubmit = async () => {
    // alert("..........................");
    if (data && data?.Final_exit_status === "OPSAUTHORISED") {
      let reqObj = {
        NET_PAYABLE_RETENTION: retentionPayable,
        NET_PAYABLE_AFTER_RETENTION: G_NET_PAYABLE_AFTER_RETENTION,
        NET_RECEIVABLE_RETENTION: retentionReceivable,
        NET_RECEIVABLE_AFTER_RETENTION: H_NET_RECEIVABLE_AFTER_RETENTION,
        employee_id: data?.data?.[0]?.candidate_id,
      };
      try {
        const authoriseEndpoint = isLocalExit
          ? `${baseEndpoint}/proceedtoauthorised`
          : "/mobilization/proceedtoauthorised";

        const response = await nodeinstance.put(
          authoriseEndpoint,
          reqObj,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          localStorage.setItem("final", "true");
          navigate("/dashboard/final-exit");
        }
      } catch (error) {
        console.log("error to be seen in console", error);
      }
      return;
    } else {
      try {
        let obj = {
          employee_id: data && data?.data[0]?.candidate_id,
          vpayamount: B_PAID_VPAY,
          grossPayable: C_GROSS_PAYABLE,
          NetPaybale: G_NET_PAYABLE_AFTER_RETENTION,
          netReceivable: H_NET_RECEIVABLE_AFTER_RETENTION,
          retainedFromPayable: E_RETAINED_FROM_PAYABLE,
          retainedFromRepatriation: F_RETAINED_FROM_REPATRIATION,
          finalPayableReceivable: I_FINAL_PAYABLE_RECEIVABLE,
          salaryCalculationMode: salaryCalculationMode,
        };
        console.log("Submitting financial data:", obj);

        const proceedEndpoint = isLocalExit
          ? `${baseEndpoint}/proceedtolocalexit`
          : `/mobilization/proceedtofinalexit`;

        const response = await nodeinstance.put(
          proceedEndpoint,
          obj,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          console.log(".....................");
          localStorage.setItem("final", "true");
          navigate("/dashboard/final-exit");
        }
        console.log("Data log to be seen in the console", data, value);
      } catch (error) {
        console.log("error to be printed here in console", error);
      }
    }
  };

  // Initialize amount from saved vpayamount when data loads
  // useEffect(() => {
  //   if (data?.data?.[0]?.vpayamount) {
  //     SetAmount(data.data[0].vpayamount);
  //   }
  // }, [data]);

  useEffect(() => {
    if (fandftrigger === true) {
      // alert("..............................dddddddddddd");
      onSubmit();
      setFandfTrigger(false);
    }
  }, [fandftrigger]);

  const mappedData =
    data && data?.Final_exit_status === "OPSAUTHORISED" ? NewDetails : details;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <button
        className="w-full flex items-center justify-between px-6 py-4 bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-all duration-200 group"
        onClick={toggleCollapse}
        aria-expanded={!isCollapsed}
        aria-controls="collapseWithScrollbar"
      >
        <div className="flex items-center space-x-3">
          <div className={`transform transition-transform duration-200 ${isCollapsed ? "" : "rotate-180"}`}>
            <HiOutlineChevronDown className="w-5 h-5 text-gray-600" />
          </div>
          <span className="text-sm font-bold text-gray-800 uppercase tracking-wide">
            FINANCIAL STATEMENT
          </span>
        </div>
        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium">
          {isCollapsed ? "Click to Expand" : "Click to Collapse"}
        </span>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out ${
          isCollapsed ? "max-h-0 opacity-0" : "max-h-[5000px] opacity-100"
        } overflow-hidden`}
        id="collapseWithScrollbar"
      >
        <div className="p-6 bg-white">
        <>
          <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  {titles.map((columnName, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                    >
                      {columnName}
                    </th>
                  ))}
                </tr>
              </thead>
                <tbody className="bg-white divide-gray-10">
                  {mappedData.map((listItem, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.name}
                      </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.isText ? (
                            // Handle different input fields based on field name
                            listItem.name === "PAID V.PAY" ? (
                              <input
                                type="number"
                                step="any"
                                value={amount}
                                onChange={AmountChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="0.00"
                              />
                            ) : listItem.name === "RETAINED FROM PAYABLE" ? (
                              <input
                                type="number"
                                step="any"
                                value={retentionPayable}
                                onChange={handleRetentionPayableChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="0.00"
                              />
                            ) : listItem.name === "RETAINED FROM REPATRIATION" ? (
                              <input
                                type="number"
                                step="any"
                                value={retentionReceivable}
                                onChange={handleRetentionReceivableChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="0.00"
                              />
                            ) : (
                              <input
                                type="number"
                                step="any"
                                value={amount}
                                onChange={AmountChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="0.00"
                              />
                            )
                          ) : (
                            parseFloat(listItem.value || 0).toFixed(2)
                          )}
                        </td>
                      
                    </tr>
                  ))}
                </tbody>
            </table>
          </div>
        </>
        </div>
      </div>
    </div>
  );
}
